import { IChangeTracking } from "../../../changeTracking/iChangeTracking";

export class RequestPickupDetail implements IChangeTracking {
    private _current: any;

    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
    }

    get pickupId(): string {
        return this._current.pickupId;
    }

    set pickupId(value: string) {
        this._current.pickupId = value;
    }

    get emailAddress(): string {
        return this._current.emailAddress;
    }

    set emailAddress(value: string) {
        this._current.emailAddress = value;
    }

    get contactName(): string {
        return this._current.contactName;
    }

    set contactName(value: string) {
        this._current.contactName = value;
    }

    get phoneNumber(): string {
        return this._current.phoneNumber;
    }

    set phoneNumber(value: string) {
        this._current.phoneNumber = value;
    }


    get companyName(): string {
        return this._current.companyName;
    }

    set companyName(value: string) {
        this._current.companyName = value;
    }  


    get addressLine1(): string {
        return this._current.addressLine1;
    }

    set addressLine1(value: string) {
        this._current.addressLine1 = value;
    }  


    get addressLine2(): string {
        return this._current.addressLine2;
    }

    set addressLine2(value: string) {
        this._current.addressLine2 = value;
    }  

    get city(): string {
        return this._current.city;
    }

    set city(value: string) {
        this._current.city = value;
    }

    get countryCode(): string {
        return this._current.countryCode;
    }

    set countryCode(value: string) {
        this._current.countryCode = value;
    }

    get countryName(): string {
        return this._current.countryName;
    }

    set countryName(value: string) {
        this._current.countryName = value;
    }

    get postalCode(): string {
        return this._current.postalCode;
    }

    set postalCode(value: string) {
        this._current.postalCode = value;
    }


    get regionCode(): string {
        return this._current.regionCode;
    }

    set regionCode(value: string) {
        this._current.regionCode = value;
    }
    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);

    }

    commit(): void {

        this._model = angular.copy(this._current);
    }

    toJson(): any {
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestPickupDetail.ts
 **/